export default __webpack_public_path__ + "static/media/g2022-5.352170e1.jpeg";